"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePage = void 0;
const React = __importStar(require("react"));
const Spacer_1 = require("../../components/spacer/Spacer");
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../../components/styles/theme"));
const MaxWidthWrapper_1 = require("../../components/max-width/MaxWidthWrapper");
const MarginWrapper_1 = require("../../components/margin/MarginWrapper");
const HeaderWrapper = styled_1.default.div `
	background-color: ${theme_1.default.colours.neutral.white};
	position: relative;
	z-index: ${theme_1.default.layout.zIndex.stickyHeader};
`;
const BasePage = ({ header, children }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderWrapper, { id: "task-header" },
            React.createElement(MaxWidthWrapper_1.MaxWidthWrapper, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    header))),
        children));
};
exports.BasePage = BasePage;
//# sourceMappingURL=BasePage.js.map